<template>
    <index-table
        :cols="[
            {
                value: 'serial_number',
                label: 'Serial Number',
                searchable: true,
                sortable: true,
            },
            {
                value: 'purchase_order',
                label: 'Purchase Order',
                searchable: true,
                sortable: true,
            },
            {
                value: 'customer',
                label: 'Customer',
                searchable: true,
                sortable: true,
            },
            {
                value: 'premium_status',
                label: 'Premium Status',
                searchable: true,
                sortable: true,
                customCell: 'RadioPremiumStatusCell',
            },
            {
                value: 'is_premium_authorized',
                label: 'Premium Authorized',
                searchable: true,
                sortable: true,
                filter: 'convertBoolean',
            },
            {
                value: 'notes',
                label: 'Notes',
                searchable: true,
                sortable: true,
            },
            {
                value: 'organization',
                label: 'Organization',
                display: 'name',
                searchable: true,
                sortable: true,
            },
            {
                value: 'created_by',
                label: 'Created By',
                display: 'name',
                searchable: true,
                sortable: true,
            },
            {
                value: 'created_at',
                label: 'Created',
                sortable: true,
                searchable: true,
                filter: 'localDateTime',
            },
            {
                value: 'updated_at',
                label: 'Last Updated',
                sortable: true,
                searchable: true,
                filter: 'localDateTime',
            },
        ]"
        :title="'Radios'"
        model="radios"
        :createText="createText"
        :options="options"
        data-test-id="radios-table"
        :filters="filters"
    >
        <template #disclaimer>
            <p class="disclaimer">*Only organizations with radios are shown</p>
        </template>

        <template #navigation>
            <div class="tabs">
                <button
                    data-test-id="radio-summary-table-button"
                    @click="goToSummary"
                >
                    Organization Summary
                </button>
                <button
                    class="active"
                    data-test-id="all-radios-table-button"
                    @click="goToRadios"
                >
                    View All Radios
                </button>
            </div>
        </template>

        <template #search>
            <section class="organization-selector">
                <organization-selector
                    :allowClear="true"
                    placeholder="Filter By Org"
                    :organizationId="selectedOrganizationId"
                    data-test-id="organization_radio_summary_organization_selector"
                    @update="organizationSelected"
                />
            </section>
        </template>
    </index-table>
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import OrganizationSelector from '@/components/OrganizationSelector.vue'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    components: {
        IndexTable,
        OrganizationSelector,
    },

    mixins: [needsOrganizationSlug],

    data() {
        let selectedOrganizationId = null

        if (this.$route.query.organization_id) {
            selectedOrganizationId = parseInt(this.$route.query.organization_id, 10)
        }
        return {
            selectedOrganizationId,
        }
    },

    computed: {
        filters() {
            const result = {}
            if (this.selectedOrganizationId !== null)
                return {
                    organization_id: this.selectedOrganizationId,
                }

            return result
        },

        createText() {
            let result = ''

            const { hasPermission } = this.$store.getters

            // only show create new if viewing as super admin and can create an app
            if (!this.organizationSlug && hasPermission('create radios')) {
                result = 'Create Radio'
            }

            return result
        },

        options() {
            const result = []
            const { hasPermission } = this.$store.getters

            if (!this.organizationSlug) {
                if (hasPermission('delete radios') && hasPermission('delete many radios')) {
                    result.push('deletable')
                }

                if (hasPermission('update radios')) {
                    result.push('editable')
                }

                if (hasPermission('upload radios')) {
                    result.push('importable')
                }
            }

            return result
        },
    },

    methods: {
        goToRadios() {
            this.$router.push('/radios')
        },

        goToSummary() {
            this.$router.push('/radios/summary')
        },
        organizationSelected(id) {
            this.selectedOrganizationId = id
        },
    },
}
</script>
<style lang="scss">
.organization-selector {
    width: 320px;
    top: 7px;
    position: relative;

    input {
        background-color: #fff;
        color: #000;
        height: auto;
        border-width: 0px;
    }
}

.tabs {
    padding: 0px;
    margin: 0px;

    button {
        border: 1px solid #888;
        color: #fff;
        font-size: 14px;
        background-color: transparent;
        padding: 10px 12px;
        width: 256px;
        height: 40px;
        cursor: pointer;
    }

    .button:first-child {
        border-radius: 8px 0px 0px 8px;
    }

    button:not(:last-child) {
        border-right-width: 0px;
    }

    button:last-child {
        border-radius: 0px 8px 8px 0px;
    }

    button.active {
        background-color: #212628;
    }
}
</style>
